import * as React from 'react'

function SvgImpregnationN(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 4.329 4.329" {...props}>
			<g fill="currentColor">
				<path d="M2.874 1.721a.711.711 0 01-1.422 0c0-.392.711-1.35.711-1.35s.711.958.711 1.35z" />
				<path d="M1.765 3.854v-1.01h.137l.53.793v-.793h.129v1.01h-.137l-.53-.794v.794z" />
			</g>
		</svg>
	)
}

export default SvgImpregnationN
